import { BackendModel, BackendService } from '../../core/backend.service';
import { Sugerencia } from '../sugerencia/sugerencia.model';
import { SubcategoriaProducto } from '../subcategoria-producto/subcategoria-producto.model';
import { Precio } from '../../core/precio.model';

export class CategoriaProducto extends BackendModel {

  static path = '/productos/categorias/';

  static codInterna = 'VIACOTONE';

  id: number;
  description: string;
  imagen: string;
  banner: string;
  origen: string;
  
  sugerencias?: Sugerencia[];
  subcategorias?: SubcategoriaProducto[];
  etiquetaModificacionPrecio:string;
  aumentoPrecio: number;
  fechaDesde: string;
  fechaHasta: string;
  activo:boolean;
  categoriaPadre: CategoriaProducto;
  categoriaPadreNombre:string;
  descripcionActivo:string;

  constructor(protected backendService: BackendService, model?: CategoriaProducto) {
    super(backendService, model);
  }

  get sugerenciaString() {
    let s = '';
    this.sugerencias.forEach(v => s += v.description + ', ');
    s = s.length > 100 ? s.substr(0, 100) + '[...]' : s.substr(0, s.length - 2);
    return s;
  }

  get subcategoriaString() {
    let s = '';
    this.subcategorias.forEach(v => s += v.description + ', ');
    s = s.length > 100 ? s.substr(0, 100) + '[...]' : s.substr(0, s.length - 2);
    return s;
  }

  interna() {
    return this.origen === CategoriaProducto.codInterna;
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/categoria-producto/categoria-producto.model.ts